import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendService } from 'src/app/core/services/backend-prod.service';
import { HelperService } from 'src/app/core/services/helper.service';
import { Storage } from '@ionic/storage';
import { debounceTime } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { AlertController, NavController } from '@ionic/angular';
import { MenuService } from '../core/services/menu.service';

@Component({
  selector: 'app-vendor-list',
  templateUrl: './vendor-list.page.html',
  styleUrls: ['./vendor-list.page.scss'],
})

export class VendorListPage implements OnInit {
  private incomingSearchText$ = new BehaviorSubject('');
  breadcrumbList = [
    {
      label: 'Vendor',
      url: '/baseapp/vendor-list'
    },
    {
      label: 'List',
      url: '/baseapp/vendor-list'
    }
  ];

  vendorDisplayedColumns: string[] = [
    'id', 
    'first_name', 
    'last_name', 
    'email', 
    'created_date', 
    'updated_date', 
    'action'
  ];
  vendorDataSource: any;
  // vendorDataSource: any[] = [];
  hide1200 = false;
  page_min = 0;
  page_max = 10;
  total_records = 0;
  sortBy: string = "";
  orderBy: string = "DESC";
  search = "";
  loading = true;
  bubbleshow:boolean = false;
  getVendorApi: any;
  userEditEnable = false;
  userDeleteEnable = false;
  userDetailsEnable = false;
  userAddEnable = false;
  roleId;
  vendorId: any;
  selctedVendor: any;


  constructor(
    private formBuilder: UntypedFormBuilder,
    public breakpointObserver: BreakpointObserver,
    private backendService: BackendService,
    private router: Router,
    public storage: Storage,
    public menuService: MenuService,
    public alertController: AlertController,
    public helperService: HelperService
    ) { }

  ngOnInit() {
    this.getVendor();
  }

  async confirmDeleteAlert(header, msg, vendorId) {
    const alert = await this.alertController.create({
      header: header,
      message: msg,
      buttons: [
        {
          text: 'CANCEL',
          cssClass: 'primary-text',
          handler: () => {
            alert.dismiss();
          }
        }, {
          text: 'OK',
          cssClass: 'primary-text',
          handler: () => {
            this.deleteVendor(vendorId)
          }
        }
      ]
    });
    await alert.present();
  }

  searchStringMethod(message: string) {
		this.incomingSearchText$.next(message);
	}

  clearSearch() {
    this.search = "";
    this.searchStringMethod(this.search);
  }

  getSearchOnChange(e) {
    this.searchStringMethod(e);
  }

  searchUser() {
    this.getStorage().then((res) => {
      let payload = {
        min: this.page_min,
        max: this.page_max,
        sort: this.sortBy,
        order: this.orderBy,
        q: this.search
      }
      this.backendService.PostAPICall('getAllVendors', payload, res.token).subscribe(
        async data => {
          let decoded_token
          await this.helperService.decode(res.token).then((d)=>{decoded_token=d})
          this.roleId = decoded_token.role.role_id;
          this.vendorDataSource = data.records;
          this.total_records = data.total_count;
        },
        (error) => {
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    })
  }

  blockVendorToggle(event, vendorId) {
    this.getStorage().then((res)=>{
      let payload = {
        id: vendorId,
        block: event,
      }
      this.getVendorApi = this.backendService.PostAPICall('blockVendor', payload, res.token).subscribe(
        data => {
          this.helperService.presentToast(data.msg, 2000);
        },
        (error)=>{
          //console.log(error);
          this.helperService.handleError(error);
        }
      );
    })
  }

  getVendor() {
    this.helperService.loader();
    this.getStorage().then((res)=>{
      let payload = {
        min: this.page_min,
        max: this.page_max,
        sort: this.sortBy,
        order: this.orderBy,
        q: this.search
      }
      this.getVendorApi = this.backendService.PostAPICall('getAllVendors', payload, res.token).subscribe(
        data => {
          this.helperService.closeLoader();
          this.vendorDataSource = data.records;
          this.total_records = data.total_count;
          this.loading = false;
        },
        (error)=>{
          //console.log(error);
          this.loading = false;
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  loadMore(event) {
    this.helperService.loader()
    this.page_max = this.page_max + 10;
    let payload = {
      min: this.page_min,
      max: this.page_max,
      sort: this.sortBy,
      order: this.orderBy,
      q: this.search
    }
    this.getStorage().then((res)=>{
      this.backendService.PostAPICall('getAllVendors', payload, res.token).subscribe(
        data => {
          this.helperService.closeLoader();
          this.vendorDataSource = data.records;
          event.target.complete();
          if(data.records.length == this.total_records){
            event.target.disabled = true;
          }
        },
        (error)=>{
          //console.log(error);
          event.target.complete();
          this.helperService.handleError(error);
              this.helperService.closeLoader();
        }
      );
    })
  }

  async getStorage () {
    let data = {
      token: await this.storage.get("token"),
      vendorId: await this.storage.get("id"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  editVendor(id) {
    this.router.navigate(['baseapp/vendor-list/update', id])
  }

  getVendorDetails(id) {
    this.router.navigate(['baseapp/vendor-list/details', id])
  }

  confirmVendorDelete(vendorId) {
    const header = 'Confirm!';
    const msg = "Are you sure you want to delete?"
    this.confirmDeleteAlert(header, msg, vendorId,)
  }

  deleteVendor(id) {
    this.helperService.loader();
    this.getStorage().then((res)=>{
      let url = `/vendors/users/deleteVendor/${id}`;
      this.backendService.DeleteAPICall(url, res.token).subscribe(
        (res) => {
          this.helperService.closeLoader();
          this.helperService.presentToast(res.msg, 2000);
          this.getVendor();
        },
        (error)=>{
          //console.log(error);
          this.helperService.closeLoader();
          this.helperService.presentAlert('Information', error.error.detail)
        }
      );
    })
  }

  ngOnDestroy() {
    this.getVendorApi.unsubscribe();
    this.helperService.closeLoader();
  }

  closebubblecross() {
    this.bubbleshow = false;
  }

  closebubble() {
    this.bubbleshow = false;
  }

}
